
const OPEN_SEARCH_FORM = (state) => state.isOpen = true

const CLOSE_SEARCH_FORM = (state) => state.isOpen = false

const SET_HEADER_FIX = (state, value) => state.isHeaderFix = value

const SET_PRODUCT_LIST = ({ product }, { page, productList, last, totalCount }) => {
  product.page = page
  if (productList.length) { // 정상 응답
    product.productList.push(...productList)
    if (productList.length < product.pageSize) {
      product.last = true
    }
    if(totalCount > 0) product.totalCount = totalCount
  } else {
    if (product.page === 0) {
      product.productList = productList
      product.totalCount = 0
    }
    product.last = typeof last != 'undefined' ? last : true
  }
}

const SET_TAG_LIST = ({ tag }, { tagList, totalCount }) => {
  tag.tagList = tagList
  tag.totalCount = totalCount
}

export default {
  OPEN_SEARCH_FORM,
  CLOSE_SEARCH_FORM,
  SET_HEADER_FIX,
  SET_PRODUCT_LIST,
  SET_TAG_LIST
}
